import React from "react";
import { Palette } from "lucide-react";

/**
 * Get icon for color widgets
 * @param {object} widget - Full widget object (optional, for accessing current state)
 * @returns {JSX.Element} Icon component
 */
export const getColorIcon = (widget = null) => {
  const lucideIconProps = {
    size: 24,
    style: { paddingBottom: "2px" },
  };

  return <Palette {...lucideIconProps} />;
};

export const getColorSubtitle = (widget = null) => {
  if (!widget) return "";

  const colorRgb = widget?.items?.$w1?.value || widget?.items?.$c1?.value;
  const colorTemp = widget?.items?.$w2?.value || widget?.items?.$c2?.value;
  const currentMode = widget?.items?.$w3?.value || widget?.items?.$c3?.value;

  if (currentMode === "temperature" && colorTemp) {
    return `${colorTemp}K`;
  } else if (colorRgb) {
    return `#${colorRgb}`.toUpperCase();
  }

  return "";
};

/**
 * Get patterns that this helper supports
 * @returns {string[]} Array of pattern strings
 */
export const getColorPatterns = () => {
  return ["basic.device.color", "basic.device.colorTemperature"];
};
